"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAINS = void 0;
exports.CHAINS = {
    TESTNET: {
        ACRE: "acre",
        ARBITRUM: "arbitrum",
        AURA: "aura",
        AURORA: "aurora",
        AXELAR: "Axelarnet",
        AVALANCHE: "Avalanche",
        BASE: "base",
        BINANCE: "binance",
        BNBCHAIN: "binance",
        BURNT: "burnt-2",
        CELO: "celo",
        COMDEX: "comdex-2",
        ETHEREUM: "ethereum-2",
        EVMOS: "evmos",
        FANTOM: "Fantom",
        FETCH: "fetch",
        FILECOIN: "filecoin-2",
        HERO: "hero",
        HIGHRISE: "highrise",
        IMPACTHUB: "impacthub",
        KAVA: "kava",
        KUJIRA: "kujira",
        LINEA: "linea",
        MANTLE: "mantle",
        MOONBEAM: "Moonbeam",
        NEUTRON: "neutron",
        ODIN: "odin",
        OPTIMISM: "optimism",
        OSMOSIS: "osmosis-6",
        PERSISTENCE: "persistence",
        POLYGON: "Polygon",
        POLYGONZKEVM: "polygon-zkevm",
        SECRETSNIP: "secret-snip-2",
        SEI: "sei-2",
        TERITORI: "teritori",
        TERRA: "terra-3",
        XPLA: "xpla",
    },
    MAINNET: {
        ACRE: "acre",
        AGORIC: "agoric",
        ARBITRUM: "arbitrum",
        ARCHWAY: "archway",
        ASSETMANTLE: "assetmantle",
        AURA: "aura",
        AVALANCHE: "Avalanche",
        AXELAR: "Axelarnet",
        BASE: "base",
        BINANCE: "binance",
        BNBCHAIN: "binance",
        CARBON: "carbon",
        CELO: "celo",
        COMDEX: "comdex",
        COSMOSHUB: "cosmoshub",
        CRESCENT: "crescent",
        EMONEY: "e-money",
        ETHEREUM: "Ethereum",
        EVMOS: "evmos",
        FANTOM: "Fantom",
        FETCH: "fetch",
        FILECOIN: "filecoin",
        INJECTIVE: "injective",
        IXO: "ixo",
        JUNO: "juno",
        KAVA: "kava",
        KI: "ki",
        KUJIRA: "kujira",
        LINEA: "linea",
        MANTLE: "mantle",
        MOONBEAM: "Moonbeam",
        NEUTRON: "neutron",
        OPTIMISM: "optimism",
        OSMOSIS: "osmosis",
        PERSISTENCE: "persistence",
        POLYGON: "Polygon",
        POLYGONZKEVM: "polygon-zkevm",
        PROVENANCE: "provenance",
        REBUS: "rebus",
        REGEN: "regen",
        SECRET: "secret",
        SECRETSNIP: "secret-snip",
        SEI: "sei",
        SOMMELIER: "sommelier",
        STARGAZE: "stargaze",
        STRIDE: "stride",
        TERRACLASSIC: "terra",
        TERRA: "terra-2",
        UMEE: "umee",
        XPLA: "xpla",
    },
};
//# sourceMappingURL=supported-chains-list.js.map